function ProductStructuredReviews({ product }) {
  if (!product.global_rating) return null;

  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line
      dangerouslySetInnerHTML={{ __html:
        `{
          "@context": "https://schema.org/",
          "@type": "Product",
          "name": "${product.name}",
          "image": [${product.pictures.map((p) => `"${p.standard_url}"`)}],
          "description": "${product.description}",
          "brand": {
            "@type": "Brand",
            "name": "${product.brand.name}"
          },
          "review": [${product.recent_comments.map((r) => `
          {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "${r.rating}"
            },
          }`)}],
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "${product.global_rating}",
            "ratingCount": "${product.ratings_count}"
          },
          "offers": {
            "@type": "AggregateOffer",
            "price": "${product.current_price}",
            "lowPrice": "${product.current_price}",
            "highPrice": "${product.retail_price}",
            "priceCurrency": "EUR"
          }
        }`,
      }}
    />
  );
}

export default ProductStructuredReviews;
